var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
      _vm.code !== "view"
        ? _c(
            "vxe-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              on: { click: _vm.addActivity },
            },
            [_vm._v("活动类型")]
          )
        : _vm._e(),
      _vm._l(_vm.detailVos, function (item, k) {
        return _c(
          "div",
          { key: k, staticClass: "list-wrap" },
          [
            _c(
              "el-form",
              {
                ref: "detailForm",
                refInFor: true,
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.detailForm,
                  rules: _vm.detailRule,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "活动大类", prop: "name" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.code === "view",
                                  placeholder: "请选择活动大类",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getFineList($event, k)
                                  },
                                },
                                model: {
                                  value: item.categoriesName,
                                  callback: function ($$v) {
                                    _vm.$set(item, "categoriesName", $$v)
                                  },
                                  expression: "item.categoriesName",
                                },
                              },
                              _vm._l(_vm.categoryList, function (item) {
                                return _c("el-option", {
                                  key: item.categoriesCode,
                                  attrs: {
                                    label: item.categoriesName,
                                    value: item.categoriesCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "活动细类", prop: "fineName" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cost-select",
                                on: {
                                  click: function ($event) {
                                    return _vm.openHandleClick(
                                      "fine",
                                      "activity_category_list",
                                      "fineCode",
                                      k,
                                      null,
                                      {
                                        categoriesCode: item.categoriesCode,
                                        actType: "project",
                                      }
                                    )
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly: true,
                                    placeholder: "活动细类",
                                  },
                                  model: {
                                    value: item.fineName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fineName", $$v)
                                    },
                                    expression: "item.fineName",
                                  },
                                }),
                                _vm.code !== "view"
                                  ? _c("div", { staticClass: "clear-icon" }, [
                                      _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        on: {
                                          click: function ($event) {
                                            return _vm.clearFn(
                                              $event,
                                              "fine",
                                              k,
                                              null
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "产品系列", prop: "productType" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled:
                                    _vm.code === "view" || _vm.showProduct,
                                  placeholder: "请选择产品系列",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getProductTypeList($event, k)
                                  },
                                },
                                model: {
                                  value: item.productTypeName,
                                  callback: function ($$v) {
                                    _vm.$set(item, "productTypeName", $$v)
                                  },
                                  expression: "item.productTypeName",
                                },
                              },
                              _vm._l(_vm.productTypeList, function (item) {
                                return _c("el-option", {
                                  key: item.dictCode,
                                  attrs: {
                                    label: item.dictValue,
                                    value: item.dictCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    item.categoriesCode === "TRLX0042"
                      ? _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "品鉴会类型",
                                  prop: "tastingTypeName",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: _vm.code === "view",
                                      placeholder: "请选择品鉴会类型",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.getActTypeList($event, k)
                                      },
                                    },
                                    model: {
                                      value: item.tastingTypeName,
                                      callback: function ($$v) {
                                        _vm.$set(item, "tastingTypeName", $$v)
                                      },
                                      expression: "item.tastingTypeName",
                                    },
                                  },
                                  _vm._l(_vm.actTypeList, function (item) {
                                    return _c("el-option", {
                                      key: item.dictCode,
                                      attrs: {
                                        label: item.dictValue,
                                        value: item.dictCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.fineCode === "XL274"
                      ? _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "返厂游状态",
                                  prop: "isReturnName",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: _vm.code === "view",
                                      placeholder: "请选择是否返厂游",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.getyesOrNoList($event, k)
                                      },
                                    },
                                    model: {
                                      value: item.isReturnName,
                                      callback: function ($$v) {
                                        _vm.$set(item, "isReturnName", $$v)
                                      },
                                      expression: "item.isReturnName",
                                    },
                                  },
                                  _vm._l(_vm.yesOrNo, function (item) {
                                    return _c("el-option", {
                                      key: item.dictCode,
                                      attrs: {
                                        label: item.dictValue,
                                        value: item.dictCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.categoriesCode === "TRLX0071" &&
                    (item.fineCode == "XL304" || item.fineCode == "XL270")
                      ? _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    "是否为已建档" +
                                    (item.fineCode == "XL304"
                                      ? "企业"
                                      : item.fineCode == "XL270"
                                      ? "个人"
                                      : ""),
                                  "label-width": "130px",
                                  size: "small",
                                  prop: "ext43",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: _vm.code === "view",
                                      placeholder:
                                        "请选择是否为已建档" +
                                        (item.fineCode == "XL304"
                                          ? "企业"
                                          : item.fineCode == "XL270"
                                          ? "个人"
                                          : ""),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.getCompanyYN($event, k)
                                      },
                                    },
                                    model: {
                                      value: item.ext44,
                                      callback: function ($$v) {
                                        _vm.$set(item, "ext44", $$v)
                                      },
                                      expression: "item.ext44",
                                    },
                                  },
                                  _vm._l(
                                    _vm.tastingIsOpenList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.dictCode,
                                        attrs: {
                                          label: item.dictValue,
                                          value: item.dictCode,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.code !== "view"
                      ? _c(
                          "el-col",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-end",
                              "align-items": "center",
                              "margin-bottom": "18px",
                            },
                            attrs: { span: 2 },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                circle: "",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteActivity(k)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.code !== "view"
                  ? _c(
                      "vxe-button",
                      {
                        staticStyle: { "margin-bottom": "10px" },
                        on: {
                          click: function ($event) {
                            return _vm.addDetail(k, item)
                          },
                        },
                      },
                      [_vm._v("新增明细")]
                    )
                  : _vm._e(),
                _c(
                  "el-tabs",
                  {
                    attrs: {
                      type: "card",
                      closable: _vm.code == "view" ? false : true,
                    },
                    on: {
                      "tab-remove": function ($event) {
                        return _vm.removeTab($event, k)
                      },
                    },
                    model: {
                      value: item.editableTabsValue,
                      callback: function ($$v) {
                        _vm.$set(item, "editableTabsValue", $$v)
                      },
                      expression: "item.editableTabsValue",
                    },
                  },
                  _vm._l(item.activityInfo, function (act, j) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: act.tabValue,
                        attrs: {
                          label: "活动明细表单" + (j + 1),
                          name: act.tabValue,
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "关联预算", prop: "ext61" },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          disabled: _vm.code === "view",
                                          placeholder: "请选择关联预算",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeFeeBudget(
                                              $event,
                                              k,
                                              j
                                            )
                                          },
                                          focus: function ($event) {
                                            return _vm.getCategoriesCode(
                                              item.categoriesCode,
                                              k
                                            )
                                          },
                                        },
                                        model: {
                                          value: act.ext61,
                                          callback: function ($$v) {
                                            _vm.$set(act, "ext61", $$v)
                                          },
                                          expression: "act.ext61",
                                        },
                                      },
                                      _vm._l(
                                        item.budgetList,
                                        function (item, bIndex) {
                                          return _c("el-option", {
                                            key: bIndex,
                                            attrs: {
                                              label: item.feeBudgetCode,
                                              value: item.feeBudgetCode,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "公司主体", prop: "ext3" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cost-select",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openHandleClick(
                                              "company",
                                              "company_list",
                                              "companyCode",
                                              k,
                                              j,
                                              null
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: !act.budgetAccount,
                                            readonly: true,
                                            placeholder: "公司主体",
                                          },
                                          model: {
                                            value: act.ext3,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext3", $$v)
                                            },
                                            expression: "act.ext3",
                                          },
                                        }),
                                        _vm.code !== "view"
                                          ? _c(
                                              "div",
                                              { staticClass: "clear-icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearFn(
                                                        $event,
                                                        "company",
                                                        k,
                                                        j
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "预算科目", prop: "ext19" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        placeholder: "预算科目",
                                      },
                                      model: {
                                        value: act.ext19,
                                        callback: function ($$v) {
                                          _vm.$set(act, "ext19", $$v)
                                        },
                                        expression: "act.ext19",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "活动明细名称",
                                      prop: "ext1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.code === "view",
                                        placeholder: "活动明细名称",
                                      },
                                      model: {
                                        value: act.ext1,
                                        callback: function ($$v) {
                                          _vm.$set(act, "ext1", $$v)
                                        },
                                        expression: "act.ext1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "活动明细编码",
                                      prop: "actDetailCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        placeholder: "活动明细编码",
                                      },
                                      model: {
                                        value: act.actDetailCode,
                                        callback: function ($$v) {
                                          _vm.$set(act, "actDetailCode", $$v)
                                        },
                                        expression: "act.actDetailCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "活动执行时间",
                                      prop: "name",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        disabled: _vm.code === "view",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "default-time": [
                                          "00:00:00",
                                          "23:59:58",
                                        ],
                                        type: "datetimerange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeExecuteTime(
                                            $event,
                                            k,
                                            j
                                          )
                                        },
                                      },
                                      model: {
                                        value: act.executeTime,
                                        callback: function ($$v) {
                                          _vm.$set(act, "executeTime", $$v)
                                        },
                                        expression: "act.executeTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            item.ext44 === "1" &&
                            (item.fineCode == "XL304" ||
                              item.fineCode == "XL270")
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "维护列表",
                                          prop: "ext43",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "wf",
                                                  item.fineCode == "XL304"
                                                    ? "companyList"
                                                    : "personList",
                                                  item.fineCode == "XL304"
                                                    ? "companyCode"
                                                    : "personCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "维护列表",
                                              },
                                              model: {
                                                value: act.ext43,
                                                callback: function ($$v) {
                                                  _vm.$set(act, "ext43", $$v)
                                                },
                                                expression: "act.ext43",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "受益经销商",
                                      prop: "ext7",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cost-select",
                                        style: act.disableExt7
                                          ? "pointer-events: none"
                                          : "",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openHandleClick(
                                              "customer",
                                              "customer_list",
                                              "customerCode",
                                              k,
                                              j,
                                              { orgCode: _vm.userInfo.orgCode }
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            readonly: true,
                                            placeholder: "受益经销商",
                                          },
                                          model: {
                                            value: act.ext7,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext7", $$v)
                                            },
                                            expression: "act.ext7",
                                          },
                                        }),
                                        _vm.code !== "view"
                                          ? _c(
                                              "div",
                                              { staticClass: "clear-icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearFn(
                                                        $event,
                                                        "customer",
                                                        k,
                                                        j
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "经销商组织",
                                      prop: "ext67",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cost-select",
                                        style: !act.ext7
                                          ? "pointer-events: none"
                                          : "",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openHandleClick(
                                              "dealer",
                                              "dealer_organization_list",
                                              "orgCode",
                                              k,
                                              j,
                                              { customerCode: act.ext6 }
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            readonly: true,
                                            placeholder: "经销商组织",
                                          },
                                          model: {
                                            value: act.ext67,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext67", $$v)
                                            },
                                            expression: "act.ext67",
                                          },
                                        }),
                                        _vm.code !== "view"
                                          ? _c(
                                              "div",
                                              { staticClass: "clear-icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearFn(
                                                        $event,
                                                        "dealer",
                                                        k,
                                                        j
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "受益组织", prop: "ext5" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cost-select",
                                        style: act.disableExt7
                                          ? "pointer-events: none"
                                          : "",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openHandleClick(
                                              "org",
                                              "org_list",
                                              "orgCode",
                                              k,
                                              j,
                                              null
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: _vm.showOrg === "1",
                                            readonly: true,
                                            placeholder: "受益组织",
                                          },
                                          model: {
                                            value: act.ext5,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext5", $$v)
                                            },
                                            expression: "act.ext5",
                                          },
                                        }),
                                        _vm.code !== "view"
                                          ? _c(
                                              "div",
                                              { staticClass: "clear-icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearFn(
                                                        $event,
                                                        "org",
                                                        k,
                                                        j
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "负责人", prop: "ext40" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cost-select",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openHandleClick(
                                              "person",
                                              "person_list",
                                              "positionCode",
                                              k,
                                              j,
                                              null
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            readonly: true,
                                            placeholder: "负责人",
                                          },
                                          model: {
                                            value: act.ext40,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext40", $$v)
                                            },
                                            expression: "act.ext40",
                                          },
                                        }),
                                        _vm.code !== "view"
                                          ? _c(
                                              "div",
                                              { staticClass: "clear-icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearFn(
                                                        $event,
                                                        "person",
                                                        k,
                                                        j
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            item.ext68 == "act-detail-template-2"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "周期", prop: "ext38" },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: _vm.code === "view",
                                              placeholder: "周期",
                                            },
                                            model: {
                                              value: act.ext38,
                                              callback: function ($$v) {
                                                _vm.$set(act, "ext38", $$v)
                                              },
                                              expression: "act.ext38",
                                            },
                                          },
                                          _vm._l(
                                            _vm.cycleList,
                                            function (pItem) {
                                              return _c("el-option", {
                                                key: pItem.dictValue,
                                                attrs: {
                                                  label: pItem.dictValue,
                                                  value: pItem.dictCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-2"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "阶梯", prop: "ext77" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "ladder",
                                                  "ladder_list",
                                                  "ladderCode",
                                                  k,
                                                  j,
                                                  {
                                                    productLevelType: "ladder",
                                                    enableStatus: "009",
                                                  },
                                                  "GET"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "阶梯",
                                              },
                                              model: {
                                                value: act.ext77,
                                                callback: function ($$v) {
                                                  _vm.$set(act, "ext77", $$v)
                                                },
                                                expression: "act.ext77",
                                              },
                                            }),
                                            _vm.code !== "view"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "clear-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-close",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearFn(
                                                            $event,
                                                            "ladder",
                                                            k,
                                                            j
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-2"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "家数", prop: "ext36" },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            placeholder: "家数",
                                          },
                                          model: {
                                            value: act.ext36,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext36", $$v)
                                            },
                                            expression: "act.ext36",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-3"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "周期", prop: "ext38" },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: _vm.code === "view",
                                              placeholder: "周期",
                                            },
                                            model: {
                                              value: act.ext38,
                                              callback: function ($$v) {
                                                _vm.$set(act, "ext38", $$v)
                                              },
                                              expression: "act.ext38",
                                            },
                                          },
                                          _vm._l(
                                            _vm.cycleList,
                                            function (pItem) {
                                              return _c("el-option", {
                                                key: pItem.dictValue,
                                                attrs: {
                                                  label: pItem.dictValue,
                                                  value: pItem.dictCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-3"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "阶梯", prop: "ext77" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "ladder",
                                                  "ladder_list",
                                                  "ladderCode",
                                                  k,
                                                  j,
                                                  {
                                                    productLevelType: "ladder",
                                                    enableStatus: "009",
                                                  },
                                                  "GET"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "阶梯",
                                              },
                                              model: {
                                                value: act.ext77,
                                                callback: function ($$v) {
                                                  _vm.$set(act, "ext77", $$v)
                                                },
                                                expression: "act.ext77",
                                              },
                                            }),
                                            _vm.code !== "view"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "clear-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-close",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearFn(
                                                            $event,
                                                            "ladder",
                                                            k,
                                                            j
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-3"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "家数", prop: "ext36" },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            placeholder: "家数",
                                          },
                                          model: {
                                            value: act.ext36,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext36", $$v)
                                            },
                                            expression: "act.ext36",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "执行次数", prop: "ext37" },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        disabled: _vm.code === "view",
                                        controls: false,
                                        precision: 0,
                                        placeholder: "执行次数",
                                      },
                                      model: {
                                        value: act.ext37,
                                        callback: function ($$v) {
                                          _vm.$set(act, "ext37", $$v)
                                        },
                                        expression: "act.ext37",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            item.fineCode === "XL295"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "是否1978赠酒",
                                          prop: "isGift",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: _vm.code === "view",
                                              placeholder: "是否1978赠酒",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeGiftWine(
                                                  $event,
                                                  k,
                                                  j,
                                                  _vm.yesOrNo
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.isGift,
                                              callback: function ($$v) {
                                                _vm.$set(act, "isGift", $$v)
                                              },
                                              expression: "act.isGift",
                                            },
                                          },
                                          _vm._l(_vm.yesOrNo, function (item) {
                                            return _c("el-option", {
                                              key: item.dictCode,
                                              attrs: {
                                                label: item.dictValue,
                                                value: item.dictCode,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.tastingTypeCode === "TASTING" ||
                            item.tastingTypeCode === "GROUP" ||
                            act.isGift === "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isGift === "Y"
                                              ? "赠酒名称"
                                              : "品鉴用酒",
                                          prop: "tastingWineName",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "tastingWine",
                                                  act.isGift === "Y"
                                                    ? "tastingWine_1978_list"
                                                    : "tastingWine_list",
                                                  "productCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder:
                                                  act.isGift === "Y"
                                                    ? "赠酒名称"
                                                    : "品鉴用酒",
                                              },
                                              model: {
                                                value: act.tastingWineName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    act,
                                                    "tastingWineName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "act.tastingWineName",
                                              },
                                            }),
                                            _vm.code !== "view"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "clear-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-close",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearFn(
                                                            $event,
                                                            "tastingWine",
                                                            k,
                                                            j
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.tastingTypeCode === "TASTING" ||
                            item.tastingTypeCode === "GROUP" ||
                            act.isGift === "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isGift === "Y"
                                              ? "赠酒数量"
                                              : "品鉴数量",
                                          prop: "tastingNumber",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            controls: false,
                                            precision: 0,
                                            placeholder:
                                              act.isGift === "Y"
                                                ? "赠酒数量"
                                                : "品鉴数量",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeTastingNumber(
                                                $event,
                                                k,
                                                j
                                              )
                                            },
                                          },
                                          model: {
                                            value: act.tastingNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                act,
                                                "tastingNumber",
                                                $$v
                                              )
                                            },
                                            expression: "act.tastingNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.tastingTypeCode === "TASTING" ||
                            item.tastingTypeCode === "GROUP"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "餐费标准",
                                          prop: "mealFeeStandard",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            controls: false,
                                            precision: 2,
                                            placeholder: "餐费标准",
                                          },
                                          model: {
                                            value: act.mealFeeStandard,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                act,
                                                "mealFeeStandard",
                                                $$v
                                              )
                                            },
                                            expression: "act.mealFeeStandard",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            ((item.tastingTypeCode === "TASTING" ||
                              item.tastingTypeCode === "GROUP") &&
                              act.isOpen === "1") ||
                            act.isGift === "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "是否开瓶扫码验证",
                                          prop: "isOpen",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: "",
                                              placeholder: "是否开瓶扫码验证",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changePayType(
                                                  $event,
                                                  k,
                                                  j,
                                                  _vm.tastingIsOpenList
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.isOpen,
                                              callback: function ($$v) {
                                                _vm.$set(act, "isOpen", $$v)
                                              },
                                              expression: "act.isOpen",
                                            },
                                          },
                                          _vm._l(
                                            _vm.tastingIsOpenList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.dictCode,
                                                attrs: {
                                                  label: item.dictValue,
                                                  value: item.dictCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            ((item.tastingTypeCode === "TASTING" ||
                              item.tastingTypeCode === "GROUP") &&
                              act.allowPjOrder) ||
                            act.isGift === "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "是否品鉴酒订单",
                                          prop: "allowPjOrder",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: "",
                                              placeholder: "是否品鉴酒订单",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeAllowPjOrder(
                                                  $event,
                                                  k,
                                                  j,
                                                  _vm.yesOrNo
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.allowPjOrder,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  act,
                                                  "allowPjOrder",
                                                  $$v
                                                )
                                              },
                                              expression: "act.allowPjOrder",
                                            },
                                          },
                                          _vm._l(_vm.yesOrNo, function (item) {
                                            return _c("el-option", {
                                              key: item.dictCode,
                                              attrs: {
                                                label: item.dictValue,
                                                value: item.dictCode,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.isGift !== "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isOpen === "1"
                                              ? "申请金额（餐费）"
                                              : "申请金额",
                                          prop: "applyAmount",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            controls: false,
                                            precision: 2,
                                            placeholder: "申请金额",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.changeApplyAmount(
                                                $event,
                                                k,
                                                j
                                              )
                                            },
                                          },
                                          model: {
                                            value: act.applyAmount,
                                            callback: function ($$v) {
                                              _vm.$set(act, "applyAmount", $$v)
                                            },
                                            expression: "act.applyAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            (item.tastingTypeCode === "TASTING" ||
                              item.tastingTypeCode === "GROUP") &&
                            act.isOpen === "1"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isGift === "Y"
                                              ? "赠酒金额"
                                              : "品鉴用酒金额",
                                          prop: "productAmount",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            disabled: "",
                                            controls: false,
                                            precision: 2,
                                            placeholder:
                                              act.isGift === "Y"
                                                ? "赠酒金额"
                                                : "品鉴用酒金额",
                                          },
                                          model: {
                                            value: act.productAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                act,
                                                "productAmount",
                                                $$v
                                              )
                                            },
                                            expression: "act.productAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.isGift !== "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isOpen === "1"
                                              ? "支付方式（餐费）"
                                              : "支付方式",
                                          prop: "payType",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: _vm.code === "view",
                                              placeholder: "请选择支付方式",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changePayType(
                                                  $event,
                                                  k,
                                                  j,
                                                  act.payTypes
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.payType,
                                              callback: function ($$v) {
                                                _vm.$set(act, "payType", $$v)
                                              },
                                              expression: "act.payType",
                                            },
                                          },
                                          _vm._l(
                                            act.payTypes,
                                            function (pItem) {
                                              return _c("el-option", {
                                                key: pItem.dictValue,
                                                attrs: {
                                                  label: pItem.dictKey,
                                                  value: pItem.dictValue,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "负责人职位",
                                      prop: "ext70",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cost-select" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: true,
                                            placeholder: "负责人职位",
                                          },
                                          model: {
                                            value: act.ext70,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext70", $$v)
                                            },
                                            expression: "act.ext70",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "负责人组织",
                                      prop: "ext74",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cost-select" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: true,
                                            placeholder: "负责人组织",
                                          },
                                          model: {
                                            value: act.ext74,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext74", $$v)
                                            },
                                            expression: "act.ext74",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            act.warnLable
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "预警提示",
                                          prop: "warnLable",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: "" },
                                            model: {
                                              value: act.warnLable,
                                              callback: function ($$v) {
                                                _vm.$set(act, "warnLable", $$v)
                                              },
                                              expression: "act.warnLable",
                                            },
                                          },
                                          _vm._l(
                                            _vm.warnLevelData,
                                            function (pItem) {
                                              return _c("el-option", {
                                                key: pItem.dictCode,
                                                attrs: {
                                                  label: pItem.dictValue,
                                                  value: pItem.dictCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.categoriesRatio
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "活动大类使用比例",
                                          prop: "categoriesRatio",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            value: act.categoriesRatio + "%",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.categoriesCode === "TRLX0043"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "终端",
                                          prop: "terminalData",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.addFix(
                                                  "terminal",
                                                  "terminal_list",
                                                  "terminalCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "终端",
                                              },
                                              model: {
                                                value: act.terminalData,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    act,
                                                    "terminalData",
                                                    $$v
                                                  )
                                                },
                                                expression: "act.terminalData",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.categoriesCode === "TRLX0043"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "市场支持人员",
                                          prop: "userData",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.addFix(
                                                  "user",
                                                  "user_list",
                                                  "userCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "市场支持人员",
                                              },
                                              model: {
                                                value: act.userData,
                                                callback: function ($$v) {
                                                  _vm.$set(act, "userData", $$v)
                                                },
                                                expression: "act.userData",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            ((item.tastingTypeCode === "TASTING" ||
                              item.tastingTypeCode === "GROUP") &&
                              act.allowPjOrder) ||
                            act.isGift === "Y"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            act.isGift === "Y"
                                              ? "赠酒支付方式"
                                              : "品鉴用酒支付方式",
                                          prop: "tastingPayType",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled:
                                                act.allowPjOrder !== "N" ||
                                                _vm.code === "view" ||
                                                act.isGift === "Y",
                                              placeholder:
                                                act.isGift === "Y"
                                                  ? "赠酒支付方式"
                                                  : "品鉴用酒支付方式",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeTastingPayType(
                                                  $event,
                                                  k,
                                                  j,
                                                  _vm.tastingPayTypeList
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.tastingPayType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  act,
                                                  "tastingPayType",
                                                  $$v
                                                )
                                              },
                                              expression: "act.tastingPayType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.tastingPayTypeList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.dictCode,
                                                attrs: {
                                                  label: item.dictValue,
                                                  value: item.dictCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.payType == "4"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "兑付产品",
                                          prop: "ext9",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cost-select",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "product",
                                                  "redemption_product",
                                                  "materialCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                readonly: true,
                                                placeholder: "兑付产品",
                                              },
                                              model: {
                                                value: act.ext9,
                                                callback: function ($$v) {
                                                  _vm.$set(act, "ext9", $$v)
                                                },
                                                expression: "act.ext9",
                                              },
                                            }),
                                            _vm.code !== "view"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "clear-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-close",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearFn(
                                                            $event,
                                                            "product",
                                                            k,
                                                            j
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.payType == "4"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "产品编码",
                                          prop: "ext8",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            placeholder: "产品编码",
                                          },
                                          model: {
                                            value: act.ext8,
                                            callback: function ($$v) {
                                              _vm.$set(act, "ext8", $$v)
                                            },
                                            expression: "act.ext8",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-2" ||
                            item.ext68 == "act-detail-template-3"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "产品", prop: "ext32" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "choose-product",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openHandleClick(
                                                  "displayProduct",
                                                  "product_list",
                                                  "materialCode",
                                                  k,
                                                  j,
                                                  null
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            act.productData,
                                            function (pt, ptIndex) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: ptIndex,
                                                  staticStyle: {
                                                    margin: "5px 10px",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    closable:
                                                      _vm.code === "view"
                                                        ? false
                                                        : true,
                                                  },
                                                  on: {
                                                    close: function ($event) {
                                                      return _vm.deleteChooseProduct(
                                                        $event,
                                                        k,
                                                        j,
                                                        ptIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(pt.materialName) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ext68 == "act-detail-template-2" ||
                            item.ext68 == "act-detail-template-3"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "产品系列",
                                          prop: "ext34",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "choose-product" },
                                          _vm._l(
                                            act.productData,
                                            function (pt, ptIndex) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: ptIndex,
                                                  staticStyle: {
                                                    margin: "10px",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    closable:
                                                      _vm.code === "view"
                                                        ? false
                                                        : true,
                                                  },
                                                  on: {
                                                    close: function ($event) {
                                                      return _vm.deleteChooseProduct(
                                                        $event,
                                                        k,
                                                        j,
                                                        ptIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        pt.productLevelName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "活动执行细则",
                                      prop: "ext13",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        autosize: "",
                                        disabled: _vm.code === "view",
                                        type: "textarea",
                                        placeholder: "活动执行细则",
                                      },
                                      model: {
                                        value: act.ext13,
                                        callback: function ($$v) {
                                          _vm.$set(act, "ext13", $$v)
                                        },
                                        expression: "act.ext13",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.code === "view"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "预算扣减编码",
                                          prop: "budgetCode",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            placeholder: "预算扣减编码",
                                          },
                                          model: {
                                            value: act.budgetCode,
                                            callback: function ($$v) {
                                              _vm.$set(act, "budgetCode", $$v)
                                            },
                                            expression: "act.budgetCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.code === "view"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "预算扣减财年",
                                          prop: "fiscalYear",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            placeholder: "预算扣减财年",
                                          },
                                          model: {
                                            value: act.fiscalYear,
                                            callback: function ($$v) {
                                              _vm.$set(act, "fiscalYear", $$v)
                                            },
                                            expression: "act.fiscalYear",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.code === "view"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "预算扣减金额",
                                          prop: "adjustmentAmount",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            placeholder: "预算扣减金额",
                                          },
                                          model: {
                                            value: act.adjustmentAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                act,
                                                "adjustmentAmount",
                                                $$v
                                              )
                                            },
                                            expression: "act.adjustmentAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.fineCode === "XL289" ||
                            item.fineCode === "XL276"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            item.fineCode === "XL289"
                                              ? "是否关联陈列协议模版"
                                              : "是否关联包量协议模版",
                                          prop: "correlationAgree",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: _vm.code === "view",
                                              placeholder:
                                                item.fineCode === "XL289"
                                                  ? "是否关联陈列协议模版"
                                                  : "是否关联包量协议模版",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeCorrelationAgree(
                                                  $event,
                                                  k,
                                                  j,
                                                  _vm.yesOrNo
                                                )
                                              },
                                            },
                                            model: {
                                              value: act.correlationAgree,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  act,
                                                  "correlationAgree",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "act.correlationAgree",
                                            },
                                          },
                                          _vm._l(_vm.yesOrNo, function (item) {
                                            return _c("el-option", {
                                              key: item.dictCode,
                                              attrs: {
                                                label: item.dictValue,
                                                value: item.dictCode,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            act.correlationAgree == "Y" &&
                            (item.fineCode === "XL289" ||
                              item.fineCode === "XL276")
                              ? _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("关联协议模版"),
                                  ]),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "agreeBtn",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openModal(k, j)
                                            },
                                          },
                                        },
                                        [_vm._v("新增模版")]
                                      ),
                                      _c(
                                        "el-table",
                                        {
                                          staticStyle: {
                                            width: "90%",
                                            "margin-bottom": "10px",
                                          },
                                          attrs: {
                                            data: act.agreeCode,
                                            border: "",
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "协议模版编码",
                                              prop: "agreeCode",
                                              align: "center",
                                            },
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "协议模版名称",
                                              prop: "agreeName",
                                              align: "center",
                                            },
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "操作",
                                              width: "120",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewForm(
                                                                $event,
                                                                k,
                                                                j,
                                                                scope.$index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("查看")]
                                                      ),
                                                      _vm.code !== "view"
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteItem(
                                                                      $event,
                                                                      k,
                                                                      j,
                                                                      scope.$index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("删除")]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            act.correlationAgree == "Y" &&
                            (item.fineCode === "XL289" ||
                              item.fineCode === "XL276")
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 10 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "协议签署期",
                                          prop: "name",
                                        },
                                      },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            disabled: _vm.code === "view",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            "default-time": [
                                              "00:00:00",
                                              "23:59:59",
                                            ],
                                            type: "datetimerange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeAgreeTime(
                                                $event,
                                                k,
                                                j
                                              )
                                            },
                                          },
                                          model: {
                                            value: act.agreeTime,
                                            callback: function ($$v) {
                                              _vm.$set(act, "agreeTime", $$v)
                                            },
                                            expression: "act.agreeTime",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c("TreeTransfer", {
        ref: "treeTransfer",
        attrs: {
          tableData: _vm.orgFixData,
          customerCode: _vm.customerCode,
          typeCode: _vm.code,
          actDetailCode: _vm.actDetailCode,
        },
        on: { onOk: _vm.transferOk },
      }),
      _c("UserTreeTransfer", {
        ref: "userTreeTransfer",
        attrs: {
          tableData: _vm.orgFixData1,
          customerCode: _vm.customerCode,
          typeCode: _vm.code,
          actDetailCode: _vm.actDetailCode,
        },
        on: { onOk: _vm.userTransferOk },
      }),
      _c(
        "Modal",
        {
          attrs: {
            modalConfig: _vm.modalConfig,
            visible: _vm.modalConfig.visible,
          },
          on: {
            "update:modalConfig": function ($event) {
              _vm.modalConfig = $event
            },
            "update:modal-config": function ($event) {
              _vm.modalConfig = $event
            },
            "update:visible": function ($event) {
              return _vm.$set(_vm.modalConfig, "visible", $event)
            },
            onClose: _vm.closeModal,
          },
        },
        [
          _c(_vm.formName, {
            ref: "modalForm",
            tag: "component",
            attrs: {
              formConfig: _vm.formConfig,
              selectionList: _vm.selectionList,
              propsObj: _vm.propsObj,
            },
            on: { getAgreeList: _vm.getAgreeList },
          }),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _vm.formName === "Agree"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.confirmResource },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-close", type: "danger" },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }